export class Marketplace {
    /**
     * Method for the platform to override to have the obfuscated marketplace id retrieval of the marketplace
     * based on the platform, and return obfuscated marketplace id of the marketplace
     * @return {undefined | string} undefined
     */
    getObfuscatedMarketplaceId() {
        return undefined;
    }
    /**
     * Method for the platform to override to have the default locale retrieval of the marketplace based on
     * the platform, and return default locale of the marketplace
     *
     * @return {undefined | string} undefined
     */
    getDefaultLocale() {
        return Intl.DateTimeFormat().resolvedOptions().locale;
    }
    /**
     * Method for the platform to override to have the default currency retrieval of the marketplace based on
     * the platform, and return default currency of the marketplace
     *
     * @return {undefined | string} undefined
     */
    getDefaultCurrency() {
        return undefined;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0cGxhY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbWFya2V0cGxhY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFnQixXQUFXO0lBQzdCOzs7O09BSUc7SUFDSSwwQkFBMEI7UUFDN0IsT0FBTyxTQUFTLENBQUM7SUFDckIsQ0FBQztJQUNEOzs7OztPQUtHO0lBQ0ksZ0JBQWdCO1FBQ25CLE9BQU8sSUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDLGVBQWUsRUFBRSxDQUFDLE1BQU0sQ0FBQztJQUMxRCxDQUFDO0lBQ0Q7Ozs7O09BS0c7SUFDSSxrQkFBa0I7UUFDckIsT0FBTyxTQUFTLENBQUM7SUFDckIsQ0FBQztDQUNKIn0=